<template>
  <div class="d-flex mt-2">
    <div class="col-auto">
      <div class="text-size-30 text-center line-height-30">
        <font-awesome-icon class="" :icon="['fal', 'eye-slash']" />
      </div>
    </div>
    <div class="text-size-16 d-flex justify-content-center align-items-center">
      {{msg}}
    </div>
  </div>
</template>
<script>
export default {
  name: 'RendererHiddenModeParticipant',
  props: ['adminName', 'type'],

  computed: {
    msg() {
      return this.$t('options.hiddenPollParticipantTip', 
        {pollType : this.type, organizerName : this.adminName});
    },
  },
};
</script>

<style lang="scss" scoped>
.d-flex.mt-2 {
  max-width: 500px;
  word-break: break-word;
}
</style>
